import { reducer as fetchTeamMemberReducer } from "./fetchTeamMember";
import {
  reducer as fetchTicketListReducer,
  TICKET_FILTER_INITIAL_STATE,
} from "./fetchTicketList";
import {
  reducer as fetchUserListReducer,
  USER_FILTER_INITIAL_STATE,
} from "./fetchUserList";
import { reducer as fetchUserInfoReducer } from "./fetchUserInfo";
import { reducer as fetchTagsReducer } from "./fetchTags";
import { reducer as fetchEntityConfigReducer } from "./entityConfig/fetchEntityConfig";
import { reducer as fetchWidgetConfigReducer } from "./entityConfig/fetchWidgetConfig";
import { reducer as fetchOptInConfigReducer } from "./entityConfig/fetchOptInConfig";
import { reducer as fetchTransactionTypeReducer } from "./fetchTransactionType";
import { reducer as fetchTxsReducer } from "./fetchTxs";
import {
  reducer as fetchGroupsReducer,
  GROUP_USER_FILTER_INITIAL_STATE,
} from "./fetchGroups";
import { reducer as fetchGithubReducer } from "./fetchGithub";
import { reducer as fetchRoles } from "./roles";
import {
  reducer as macroReducer,
  MACRO_INITIAL_STATE,
} from "./macro/macro.reducer";
import {
  reducer as trialReducer,
  TRIAL_INITIAL_STATE,
} from "./trial/trial.reducer";
import {
  reducer as globalStateReducer,
  GLOBAL_STATE_INITIAL_STATE,
} from "./globalState/globalState.reducer";
import { reducer as fetchAiSupportReducer } from "./aiSupport/fetchAiSupport";
import { reducer as fetchOnchainDataSettingReducer } from "./fetchOnchainDataSetting";
import { reducer as fetchKolListReducer } from "./fetchKolList";
import { reducer as fetchKeywordListReducer } from "./fetchKeywordList";
import { reducer as fetchOrcaReducer } from "../orca/redux/fetchOrcaOnchainDetails";

const reducers = [
  fetchTeamMemberReducer,
  fetchTicketListReducer,
  fetchUserListReducer,
  fetchUserInfoReducer,
  fetchTagsReducer,
  fetchEntityConfigReducer,
  fetchGroupsReducer,
  fetchTransactionTypeReducer,
  fetchTxsReducer,
  fetchGithubReducer,
  macroReducer,
  fetchWidgetConfigReducer,
  fetchOptInConfigReducer,
  trialReducer,
  fetchRoles,
  fetchAiSupportReducer,
  fetchOnchainDataSettingReducer,
  globalStateReducer,
  fetchKolListReducer,
  fetchKeywordListReducer,
  fetchOrcaReducer,
];
const initialState = {
  radiantDetails: [],
  ticketTypeList: [],
  radiantTxs: [],
  soldRDNTTxs: [],
  magpieDetails: [],
  savedHeaderItems: {},
  txs: [],
  queryUsers: [],
  performances: {},
  fetchPerformancesPending: {},
  DIDInfo: {},
  DIDCount: 0,
  queryUsersCount: 0,
  userListCount: 0,
  groupsCount: 0,
  groupUserCount: 0,
  ticketCounts: 0,
  draftsCount: 0,
  notificationsCount: 0,
  magpieTxs: [],
  groupUsers: [],
  curveDetails: [],
  curveOnchainDetails: [],
  subscribeInfo: {},
  selectedGroup: {},
  curveTxs: [],
  soldMGPTxs: [],
  memberList: [],
  ticketList: [],
  notificationData: {},
  filter: { status: "NEW" },
  notification: {},
  filterTicketList: [],
  userList: [],
  tags: [],
  groups: [],
  userWalletInfos: {},
  searchUserWalletInfos: {},
  userInfos: {},
  fetchSearchUserWalletInfoPending: false,
  userTicketList: {},
  userTicketCounts: 0,
  userTicketAvgScoring: null,
  drafts: [],
  notifications: [],
  githubIssues: [],
  githubRepos: [],
  userSource: [],
  csvHeaders: [],
  userSourceCount: 0,
  fetchUserSourcePending: false,
  userAdminList: [],
  attributionsFilterData: {
    page: 1,
    dateRange: [
      {
        startDate: "",
        endDate: "",
        key: "selection",
      },
    ],
    searchName: "",
    sort: "created",
    order: -1,
  },
  fetchUserAdminListPending: false,
  ticketTypeList: [],
  entityConfig: {
    init: true,
    ticketTypes: [],
    signatureSignInDisabled: false,
  },
  singleAttributionFilter: {},
  roles: [],
  userHeaderItems: [],
  userBasicInfo: [],
  userOnchainWallets: [],
  tokenHoldings: [],
  tokenHoldingListFilter: {
    page: 1,
    orderData: { sort: "value", order: -1 },
    search: "",
  },
  nftHoldings: [],
  nftHoldingListFilter: {
    page: 1,
    orderData: { sort: "walletAddress", order: -1 },
    search: "",
  },
  kolList: [],
  kolListCount: 0,
  kolListFilter: {
    page: 1,
    orderData: { sort: "xFollowers", order: -1 },
    search: "",
  },
  kolGroupMemberList: [],
  kolGroupMemberListCount: 0,
  keywordList: [],
  keywordListCount: 0,
  keywordListFilter: {
    page: 1,
    orderData: { sort: "mentionCount", order: -1 },
    search: "",
  },
  ...MACRO_INITIAL_STATE,
  ...TICKET_FILTER_INITIAL_STATE,
  ...USER_FILTER_INITIAL_STATE,
  ...TRIAL_INITIAL_STATE,
  ...GROUP_USER_FILTER_INITIAL_STATE,
  ...GLOBAL_STATE_INITIAL_STATE,
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}
